import theme from '../styles/theme'

export const thousandSeparator = (val) => {
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const percentage = (val, dp = 2, hidePercentage) => {
  return `${(val / 100).toFixed(dp)}${hidePercentage ? '' : '%'}`
}

export const formatValueChange = (valueChange, changeUnit, dashIfZero, dp = 2) => {
  if (Number(valueChange) === 0) {
    return dashIfZero ? '-' : 'No Change'
  }

  const prefix = valueChange > 0 ? '+' : ''
  switch (changeUnit) {
    case '%': {
      const percentageValue = percentage(valueChange, dp)
      if (Number(percentageValue.replace('%', '')) === 0) {
        return dashIfZero ? '-' : 'No Change'
      }
      return `${prefix}${percentageValue}`
    }
    case 'bps': return `${prefix}${valueChange}bps`
    default: return `${prefix}${valueChange}${changeUnit || ''}`
  }
}

export const getValueChangeColour = (valueChange, isCost) => {
  if (Number(valueChange) === 0) {
    return theme.colours.black
  }
  if (valueChange > 0) {
    return isCost ? theme.colours.red : theme.colours.green
  }
  return isCost ? theme.colours.green : theme.colours.red
}

export const formatParticipantName = (participant) => {
  let name = participant.firstName
  if (participant.lastName) {
    name += ` ${participant.lastName}`
  }
  return name
}
